interface CanvasProgressProps {
  value: number;
  total: number;
  /** Read aloud and shown above the bar, e.g. "2 of 4 questions". */
  label: string;
}

/** A small labelled meter for how much of a canvas is filled in. */
export function CanvasProgress({ value, total, label }: CanvasProgressProps) {
  const share = total > 0 ? Math.min(100, Math.round((value / total) * 100)) : 0;
  return (
    <div className={`canvas-progress ${share === 100 ? "complete" : ""}`}>
      <span aria-live="polite">{label}</span>
      <div
        className="canvas-progress-track"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={value}
      >
        <span style={{ width: `${share}%` }} />
      </div>
    </div>
  );
}
